import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ROUTES, getPostAuthPath } from '@/constants';
import { Spinner } from '@/components/ui';

/**
 * Public-only routes (login, etc.). Redirect authenticated users into the app.
 */
export function PublicRoute() {
  const { isAuthenticated, isBootstrapping, user } = useAuth();

  if (isBootstrapping) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--background)]">
        <Spinner className="h-8 w-8" label="Validando sessão" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={getPostAuthPath(user)} replace />;
  }

  return <Outlet />;
}
